'use client'

import { Builder, withChildren } from '@builder.io/react'

import { Tile } from './Tile'
import { defaultInfoSection } from './Tile.builder.defaults'

Builder.registerComponent(withChildren(Tile), {
  name: 'Tile',
  defaultChildren: [defaultInfoSection() as any],
  description: 'Custom tiles with editing regions',
  defaultStyles: {
    alignItems: 'center',
  },
  inputs: [
    {
      name: 'variant',
      type: 'text',
      enum: ['program', 'testimonial', 'testimonialCircle'],
      defaultValue: 'testimonial',
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/layout-bottombar-inactive.svg',
})
